<div class="img-wrapper" *ngIf="src; else defaultImage">
  <img
    [src]="src"
    (error)="error()"
    [alt]="alt"
    [class]="class"
    [style]="style" />
  <div class="content slide-bottom" *ngIf="unsplashDefinition">
    Photo by
    <a
      target="_blank"
      [href]="
        unsplashDefinition.user.links.html +
        '?utm_source=tsolife&utm_medium=referral'
      "
      >{{ unsplashDefinition.user.name }}</a
    >
    on
    <a
      target="_blank"
      [href]="'https://unsplash.com/?utm_source=tsolife&utm_medium=referral'"
      >Unsplash</a
    >
  </div>
</div>

<ng-template #defaultImage>
  <div class="img-wrapper">
    <img
      src="https://dummyimage.com/200/ebebeb/bdbdbd.jpg?text=Unavailable"
      [style]="style"
      [alt]="alt"
      [class]="class" />
  </div>
</ng-template>
